import React from 'react'
import Cartas from '../../components/cartas/Cartas.jsx'
import styled from 'styled-components'
import { useState, useEffect} from 'react'
import { collection, getDocs } from "firebase/firestore";
import { db } from '../../firebase-config.js';
import SearchIcon from '@mui/icons-material/Search';


const Container = styled.div`
display: flex;
justify-content: left;
flex-wrap: wrap;
align-items: stretch;

`
//#region Navbar CSS
const Navbar = styled.div`
width: 100%;
padding:10px;
left: 95%;
`

const Wrapper = styled.div`
display: block;
align-items: right;
justify-content: right;
width: 100%;
/* margin-right:  100px; */
`


const Search = styled.div`
  height: 35px;
  display: flex;
  float: right;
  /* margin: 10px 40px; */
  
  .item{
    color: #c5c5c5;
    display: flex;
    height: 34px;
    width: 27px;
  }

input{
  border-radius: 11px;
  line-height: 25px;
  border: 0;
  background-color: #eee;
  outline: none;
  width: 200px;
  padding: 7px;
  font-weight: 500;

  &::placeholder{
    font-size: 15px;
    padding: 5px;
  }
}
`
//#endregion


const Contenedor = () => {
    const [events, setEvents] = useState([]);

    
    // Get Events
  useEffect(()=>{
    getEvents()
  },
  []);

  async function getEvents() {
    let list = []

    try{

      const querySnapshot = await getDocs(collection(db, "events"));
      querySnapshot.docs.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data() })
      });
      setEvents(list);
      
    }catch(err){
    }
  }

     // Filter Events
  const searchText = async (item) => {    

    const value = item.target.value;
    console.log(value);
    if(value.length > 0){

      const filteredEvents = events.filter((e) => {
        return `${e.name}`
          .toLowerCase()
          .includes(item.target.value.toLowerCase().replace(' ', '-'));
      });

      setEvents(filteredEvents)
    }else{
    getEvents()
    }

  }
    

  return (
     
       <Navbar>
          <Wrapper>
            <Search >
              <SearchIcon className='item' />
              <input type="text" name="input" placeholder='Buscar...' onChange={(e) => searchText(e)} />
              <div>
              </div>
            </Search>
          </Wrapper>
      

    <Container>
        {events.map((item)=>(
          <Cartas item={item} key={item.id}/>   
          )) }
        
    </Container>
    </Navbar>
  )
}

export default Contenedor